var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMantenimiento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.14,
    x2: 25,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25,
    x2: 25,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.22,50,0,38.79,0,25S11.22,0,25,0s25,11.21,25,25-11.22,25-25,25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.78,13.43l2.21,2.21-.35.35-2.21-2.21.35-.35ZM20.24,31.5c.69,1.59.34,3.41-.88,4.63-.79.79-1.84,1.23-2.96,1.23-.14,0-.28,0-.42-.02l1.24-1.24.05-3.85-3.76.05-1.3,1.3c-.13-1.25.3-2.49,1.21-3.39.79-.79,1.84-1.23,2.96-1.23.58,0,1.14.12,1.67.35l.51.22,10.97-10.97-.22-.51c-.69-1.59-.34-3.41.88-4.64.79-.79,1.84-1.23,2.96-1.23.14,0,.29,0,.43.02l-1.29,1.29-.05,3.76,3.85-.05,1.25-1.25c.13,1.24-.3,2.48-1.21,3.39-.79.79-1.85,1.23-2.96,1.23-.58,0-1.14-.12-1.67-.34l-.5-.22-10.97,10.97.22.51ZM37.48,37.39l-.04.04c-.25.25-.57.38-.92.38s-.67-.13-.92-.38l-5.39-5.39,1.84-1.84,5.39,5.39c.49.49.51,1.28.04,1.79M39.4,36.07h.01s-.02-.02-.02-.02c-.09-.59-.37-1.15-.82-1.6l-1.23-1.23h0s-4.16-4.16-4.16-4.16l.75-.75-1.15-1.15-2.24,2.24-3.33-3.33,4.16-4.16c.58.18,1.17.28,1.79.28,1.55,0,3.01-.6,4.11-1.7,1.69-1.69,2.17-4.21,1.22-6.42l-.47-1.1-2.62,2.62-1.53.02.02-1.44,2.66-2.66-1.09-.47c-.73-.32-1.51-.48-2.32-.48-1.55,0-3.01.6-4.11,1.7-1.56,1.56-2.1,3.81-1.42,5.9l-4.15,4.15-5.94-5.94.75-.75-4.5-4.5-2.64,2.64,4.5,4.5.74-.75,5.94,5.94-4.15,4.15c-.58-.19-1.18-.28-1.79-.28-1.55,0-3.01.6-4.11,1.7-1.7,1.7-2.18,4.22-1.22,6.42l.47,1.09,2.66-2.66,1.44-.02-.02,1.53-2.62,2.62,1.1.47c.73.32,1.51.48,2.31.48,1.55,0,3.01-.6,4.11-1.7,1.56-1.56,2.1-3.81,1.42-5.89l4.16-4.16,3.33,3.33-2.24,2.24,1.15,1.15.75-.75,5.39,5.39c.55.55,1.28.86,2.06.86s1.51-.3,2.06-.86c.68-.68.95-1.62.82-2.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMantenimiento);
export default __webpack_public_path__ + "static/media/Icon_Mantenimiento.d8f4c67ebe6e7541fefe05f44b4875f8.svg";
export { ForwardRef as ReactComponent };